// resources/js/store/reducers/LayersReducer.js

const initialeState = {
    show_stack: true,
    layers_refs: [],
    layer_remove_index: 1,
    layers_stack: [],
    showLayersPanel: 'hidden',
    remove_heading_layers: null,
    active_heading_layers: null,
    layersInHeading: null,
    vectorLayer: null,
    clearVectorLayer: false,
}

const LayersReducer = (state = initialeState, action) => {
    switch (action.type) {
        case 'SET_LAYERS_REF':
            return {
                ...state,
                layers_refs: action.data
            }
        case 'TOGGLE_LAYERS_PANEL_VISIBILITY':
            return {
                ...state,
                showLayersPanel: action.data.show_layers
            }
        case 'TOGGLE_LAYERS_STACK':
            return {
                ...state,
                show_stack: !state.show_stack
            }
        case 'SHOW_LAYERS_STACK':
            return {
                ...state,
                show_stack: true
            }
        case 'HIDE_LAYERS_STACK':
            return {
                ...state,
                show_stack: false
            }
        case 'ADD_LAYER_TO_STACK':
            let addeVal = [...state.layers_stack, action.data];
            let uniq = _.uniq(addeVal);
            return {
                ...state,
                layers_stack: [...uniq]
            }
        case 'REMOVE_LAYER_FROM_STACK':
            return {
                ...state,
                layers_stack: _.without(state.layers_stack, action.data)
            }
        case 'TOGGLE_LAYER_SHOW':
            let newArray = state.layers_stack.slice();
            let newRemoveIndex = null;
            if (!_.includes(newArray, action.data.layerRef)) {
                newArray.push(action.data.layerRef);
            } else {
                newRemoveIndex = _.remove(newArray, item => item === action.data.layerRef);
            }
            return {
                ...state,
                layers_stack: newArray,
                layer_remove_index: newRemoveIndex,
            }
        case 'UPDATE_VECTOR_LAYER':
            return {
                ...state,
                vectorLayer: action.data
            }
        case 'CLEAR_LAYERS_STACK':
            let filtered = state.layers_stack.filter(item => {
                return item === 'cadastre:parcelles';
            })
            return {
                ...state,
                layers_stack: filtered
            }
        case 'CLEAR_VECTOR_LAYER':
            return {
                ...state,
                clearVectorLayer: action.data
            }
        case 'STOCK_HEADING_LAYERS_REFS':
            return {
                ...state,
                layersInHeading: action.data.layersInHeading
            }
        case 'ACTIVE_HEADING_LAYERS':
            return {
                ...state,
                active_heading_layers: action.data.heading,
                layersInHeading: (action.data.layersInHeading) ? action.data.layersInHeading : null,
                layers_stack: (action.data.layersInHeading) ? [...state.layers_stack, ...action.data.layersInHeading[0]] : [...state.layers_stack],
            }
        case 'REMOVE_HEADING_LAYERS':
            return {
                ...state,
                remove_heading_layers: action.data.heading,
                layersInHeading: (action.data.layersInHeading) ? action.data.layersInHeading : null,
                layers_stack: (action.data.layersInHeading) ? state.layers_stack.filter(item => !action.data.layersInHeading[0].includes(item)) : [...state.layers_stack],
            }
        default:
            return state
    }
}

export default LayersReducer
